import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, getUserProfile } from '../config/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { User as AppUser } from '../types/user';

interface UseAdminGuardOptions {
  redirectIfNotAdmin?: boolean;
}

export function useAdminGuard(options: UseAdminGuardOptions = {}) {
  const [user, setUser] = useState<AppUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const profile = await getUserProfile(firebaseUser.uid);
        if (profile && profile.role === 'Admin') {
          setUser(profile as AppUser);
          setIsAdmin(true);
        } else {
          setUser(profile as AppUser);
          setIsAdmin(false);
          if (options.redirectIfNotAdmin) {
            navigate('/');
          }
        }
      } else {
        setUser(null);
        setIsAdmin(false);
        if (options.redirectIfNotAdmin) {
          navigate('/');
        }
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, [navigate, options.redirectIfNotAdmin]);

  return { user, loading, isAdmin };
} 